import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=4192da7a&scoped=true&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"
import style0 from "./pricehelp.vue?vue&type=style&index=0&id=4192da7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4192da7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4192da7a')) {
      api.createRecord('4192da7a', component.options)
    } else {
      api.reload('4192da7a', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=4192da7a&scoped=true&", function () {
      api.rerender('4192da7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22Y9J5gGaYK0t/JS/pricehelp.vue"
export default component.exports